
  import { Component, Prop, Vue } from 'vue-property-decorator';
  
  @Component({
    name: 'Tooltip'
  })
  export default class Tooltip extends Vue {
    @Prop({ required: true }) id!: string;
    @Prop({ required: true }) localizationKey!: string;
    @Prop({ required: true }) initialClassName!: string;
    @Prop({ required: true }) className!: string;
    @Prop({ required: true }) hideClassName!: string;
    @Prop({ default: 300 }) animationDuration!: number;
  
    currentClassName = this.initialClassName;
    hideTimeout: NodeJS.Timeout | null = null;
  
    show(): void {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      
      this.currentClassName = this.initialClassName;
      this.$nextTick(() => {

        setTimeout(() => {
          this.currentClassName = this.className;
        }, 50);
      });
    }
  
    hide(): void {
      this.currentClassName = this.hideClassName;
      this.hideTimeout = setTimeout(() => {
        if (this.$el && this.$el.parentNode) {
          this.$el.parentNode.removeChild(this.$el);
        }
      }, this.animationDuration);
    }
  }
  